import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { loadUser } from '../../redux/slices/authSlice';
import LoadingSpinner from '../common/LoadingSpinner';

export default function PrivateRoute({ requiredRoles }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthenticated, loading, user } = useSelector((state) => state.auth);
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (token && !user && !loading) {
      dispatch(loadUser());
    }
  }, [dispatch, token, user, loading]);

  if (token && (loading || (!user && !isAuthenticated))) {
    return <LoadingSpinner overlay message="Authenticating..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (requiredRoles && requiredRoles.length > 0 && user) {
    const hasRequiredRole = requiredRoles.includes(user.role);
    if (!hasRequiredRole) {
      return <Navigate to="/" replace />;
    }
  }

  return <Outlet />;
}
